import { render, staticRenderFns } from "./ShashaReturnPolicy.vue?vue&type=template&id=f011073a&scoped=true&"
import script from "./ShashaReturnPolicy.vue?vue&type=script&lang=ts&"
export * from "./ShashaReturnPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./ShashaReturnPolicy.vue?vue&type=style&index=0&id=f011073a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f011073a",
  null
  
)

export default component.exports